// extracted by mini-css-extract-plugin
module.exports = {"formButtonGroup":"_17eWu","root":"_2D1PA","logo":"ug5uY","text":"_3qBia"};